<template>
  <div class="video-wrapper">
    <iframe
      :src="embedUrl"
      frameborder="0"
      allowfullscreen
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    ></iframe>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";

export default defineComponent({
  props: {
    youtubeUrl: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const extractVideoId = (url) => {
      const regex =
        /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^\s&?/]+)/;
      const match = url.match(regex);
      return match ? match[1] : null;
    };

    const embedUrl = computed(() => {
      const id = extractVideoId(props.youtubeUrl);
      return id ? `https://www.youtube.com/embed/${id}` : "";
    });

    return {
      embedUrl,
    };
  },
});
</script>

<style lang="scss">
.video-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 8px;
  background: #000;
  width: 100%;
}

.video-wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
